import { useEffect, useState } from "react";

/**
 * `value`, but only after it has stopped changing for `delayMs`. For text
 * filters that drive a query: without it every keystroke fired a request.
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
